import React, { useEffect, useState, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchasePopup } from './components/PurchasePopup';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { VideoIntroPopup } from './components/VideoIntroPopup';
import { ProductPreviewCarousel } from './components/ProductPreviewCarousel';
import { UrgencyModule } from './components/UrgencyModule';
import { CheckIcon, XIcon, ShieldIcon, DownloadIcon, UsersIcon, ClockIcon, StarIcon, ZapIcon, AwardIcon, ChevronDownIcon, BriefcaseIcon } from 'lucide-react';
const PURCHASE_URL = 'https://gf0puq-6f.myshopify.com/cart/52842799333600:1?channel=buy_button';
const MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
function getTodayInSpanish() {
  const today = new Date();
  const day = today.getDate();
  const month = MESES_ES[today.getMonth()];
  return `${day} de ${month}`;
}
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [todayLabel] = useState(getTodayInSpanish());
  // Meta Pixel injection
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1486404246405720');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1486404246405720&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      compraSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0" data-mp="3glea6jyr55fp">
      <PurchasePopup data-id="element-1" data-mp="3gm61vjp8aj0p" />
      <ExitIntentPopup data-id="element-2" data-mp="3gja6o34rm8fy" />

      {/* Top Urgency Bar — Premium Deep Navy & Gold */}
      <div className="w-full bg-gradient-to-r from-slate-950 via-slate-900 to-slate-950 text-white py-3 px-4 text-center sticky top-0 z-50 border-b border-yellow-500/50 shadow-[0_4px_25px_rgba(0,0,0,0.5)] relative overflow-hidden" data-id="element-3" data-mp="3bnuvxk220snr">
        <div className="absolute inset-0 bg-[linear-gradient(90deg,transparent_0%,rgba(234,179,8,0.05)_50%,transparent_100%)]" data-id="element-4" data-mp="2xuwtxev3w2b8"></div>
        <div className="max-w-7xl mx-auto relative z-10" data-id="element-5" data-mp="2swliizp5xjqw">
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs md:text-sm" data-id="element-6" data-mp="2stzbr2a3j89q">
            <span className="flex items-center gap-2" data-id="element-7" data-mp="18byasb3eml36">
              <span className="text-yellow-500 animate-pulse" data-id="element-8" data-mp="1d59kcjzlpfys">⚖️</span>
              <span className="font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 uppercase tracking-widest drop-shadow-sm" data-id="element-9" data-mp="yg3mp0gevxt0">
                Oferta exclusiva solo por hoy {todayLabel}
              </span>{' '}
              <span className="text-slate-400 font-medium hidden sm:inline" data-id="element-10" data-mp="1r267obgigfax">
                — Expira en:
              </span>{' '}
              <CountdownTimer data-id="element-11" data-mp="1i3uimdvalpkl" />
            </span>
          </div>
          <div className="text-[11px] md:text-xs text-slate-400 mt-1 text-center font-medium tracking-wide" data-id="element-12" data-mp="1i5ngb3nxgzgg">
            Últimos <span className="text-red-400 font-bold" data-id="element-13" data-mp="6ofd2lp0ppdv">4 cupos</span> al
            precio promocional + 6 bonus
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black py-12 px-4 relative overflow-hidden" data-id="element-14" data-mp="anwjbhc9qqk3">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-72 bg-amber-400/15 rounded-full blur-3xl pointer-events-none" data-id="element-15" data-mp="m5nhbfw4ixs5"></div>
        <div className="absolute bottom-0 left-1/4 w-72 h-72 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-16" data-mp="c898a1cj5b9v"></div>
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
        backgroundSize: '48px 48px'
      }} data-id="element-17" data-mp="19w9ol4yb0e13"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-18" data-mp="vyba7zjzghll">
          <div className="flex justify-center mb-6" data-id="element-19" data-mp="3koufpdpijwav">
            <div className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-yellow-500/30 bg-slate-900/60 backdrop-blur-md shadow-[0_0_20px_rgba(234,179,8,0.15)] hover:shadow-[0_0_30px_rgba(234,179,8,0.25)] transition-shadow duration-300" data-id="element-20" data-mp="3gmpjc77oklkj">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-21" data-mp="206a5du78lt1w"></div>
              <span className="text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-22" data-mp="253k1ttt1n4z8">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500" data-id="element-23" data-mp="29wlh42x5x6jc">
                  Para NOVELES ABOGADOS
                </span>
                <span className="text-slate-300 font-medium" data-id="element-24" data-mp="2jt82cstehzlw">
                  {' '}
                  <span className="mx-1 text-slate-600" data-id="element-25" data-mp="2nvupigf4mwcr">|</span> Válido para
                  toda la Argentina 🇦🇷
                </span>
              </span>
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight uppercase text-center tracking-tight" data-id="element-26" data-mp="thtobow3tx9i">
            <span className="relative inline-block" data-id="element-27" data-mp="yfvaiiotucp7">
              <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 drop-shadow-[0_0_15px_rgba(234,179,8,0.3)]" data-id="element-28" data-mp="yihop1683qge">
                Ahorrá 1 año
              </span>
            </span>{' '}
            de tiempo y{' '}
            <span className="relative inline-block" data-id="element-29" data-mp="2attoe8karnjv">
              <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600 drop-shadow-[0_0_15px_rgba(239,68,68,0.3)]" data-id="element-30" data-mp="25tfiox664pp0">
                evitá errores
              </span>
            </span>{' '}
            de amateur en tu{' '}
            <span className="relative inline-block" data-id="element-31" data-mp="2fp8yqqj3j1bj">
              <span className="relative z-10 text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.2)]" data-id="element-32" data-mp="2thoy9hcsgh7p">
                primer año
              </span>
              <span className="absolute bottom-1 left-0 w-full h-2 bg-yellow-500/40 -z-0 rounded-full blur-[1px]" data-id="element-33" data-mp="2pjivslizgnsl"></span>
            </span>{' '}
            como abogado
          </h1>

          <a href={PURCHASE_URL} className="block max-w-2xl mx-auto mb-8 relative group" data-id="element-34" data-mp="2yfqfdwqnm6gj">
            <div className="absolute inset-0 bg-yellow-500/20 rounded-2xl blur-2xl group-hover:bg-yellow-500/30 transition-all duration-500" data-id="element-35" data-mp="3n2pufpuey359"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iJJdpCyfxh5BQG3hJzFyXz/PRESENTACION_ERICA_Y_JIME_-_VIERNES_12_DE_JUNIO.png" alt="Mega Pack de Procuración Jurídica 2026" className="w-full h-auto relative z-10 group-hover:scale-105 transition-transform duration-500 drop-shadow-2xl" data-id="element-36" data-mp="384nml3gcmvi7" />
          </a>

          <h2 className="text-xl md:text-2xl text-yellow-400 mb-4 max-w-3xl mx-auto font-bold leading-relaxed text-center tracking-wide" data-id="element-37" data-mp="2pfhbo2lsr86y">
            TUS PRIMEROS PASOS EN LA PRÁCTICA PROFESIONAL Y PROCURACIÓN JURÍDICA
          </h2>

          <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-3xl mx-auto text-center font-light leading-relaxed" data-id="element-38" data-mp="2gfkgdi4wjb2x">
            Un sistema listo para usar para que dejes de improvisar y empieces a
            ejercer con{' '}
            <span className="font-semibold text-white" data-id="element-39" data-mp="30t14u452b2v8">seguridad</span>, sin
            perder semanas en prueba y error.
          </p>

          <div className="bg-slate-900/80 backdrop-blur-xl rounded-3xl shadow-[0_0_40px_rgba(234,179,8,0.15)] p-8 md:p-10 max-w-3xl mx-auto mt-4 mb-8 border border-yellow-500/20 relative overflow-hidden" data-id="element-40" data-mp="2qwo9z2xs6iyw">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600" data-id="element-41" data-mp="2hwrgmo0g4vxi"></div>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-8 uppercase text-center tracking-wide" data-id="element-42" data-mp="2d486y24vqkxz">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026{' '}
              <span className="text-yellow-400" data-id="element-43" data-mp="238o9vcekxg7n">+ 6 BONUS</span>
            </h3>
            <div className="grid md:grid-cols-2 gap-5 text-left" data-id="element-44" data-mp="1y91x142ny1zd">
              {['Escrito + estructura + orden (sin caos mental)', 'Paso a paso real (lo que en la facu no te dicen)', 'Subida al PJN sin trabarte (fueros principales)', 'Honorarios con criterio (sin regalar tu laburo)', 'Primera entrevista con clientes sin quedarte en blanco', 'Comunidad +714 colegas para destrabarte rápido'].map((text, i) => <div key={i} className="flex items-start gap-3 bg-slate-800/50 p-4 rounded-xl border border-slate-700/50 hover:border-yellow-500/30 transition-colors" data-id="element-45" data-mp="nncnka44ub7u" data-mpi={i}>
                  <div className="bg-green-500/20 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-46" data-mp="3r5ntyv8pn1fb">
                    <CheckIcon className="h-4 w-4 text-green-400" data-id="element-47" data-mp="3w361qiazralq" />
                  </div>
                  <span className="text-slate-300 text-sm md:text-base font-medium" data-id="element-48" data-mp="4re4eit1nncy">
                    {text}
                  </span>
                </div>)}
            </div>
          </div>

          <p className="text-sm font-bold text-yellow-400 mb-4 text-center drop-shadow-[0_0_10px_rgba(234,179,8,0.4)]" data-id="element-49" data-mp="38d1zae9jhgwb">
            ⭐ Garantía de satisfacción 7 días ⭐
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="w-full bg-[#f8fafc] py-12 px-4 relative overflow-hidden" data-id="element-50" data-mp="2p5koo4t13o7a">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" data-id="element-51" data-mp="2p3gj7ifheh4w"></div>
        <div className="absolute top-1/2 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-52" data-mp="1wh5kkdbfqqaq"></div>
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-53" data-mp="21grxelncq4j0"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-54" data-mp="26dihdk2a1k9p">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-10 text-center uppercase leading-tight tracking-tight" data-id="element-55" data-mp="2b5rzwf12bi1y">
            Si sos novel abogado, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.1)] p-8 md:p-12 mb-10 border border-slate-100 relative overflow-hidden" data-id="element-56" data-mp="1inxvasatu6w7">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-57" data-mp="3ry6q1n5dyybz"></div>
            <p className="text-2xl md:text-4xl font-black text-red-600 mb-8 text-center tracking-tight" data-id="element-58" data-mp="3rw2ohbuymbev">
              ¿Te pasa que el miedo a equivocarte te hace tardar el triple?
            </p>
            <p className="text-lg md:text-xl text-slate-600 mb-8 text-center font-medium" data-id="element-59" data-mp="3i23n4f2pmvnz">
              Porque una cosa es saber Derecho… y otra muy distinta es ejercer
              en el mundo real, donde:
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-60" data-mp="3482um32cq4w2">
              {['Un detalle te puede hacer perder días', 'Un formato mal armado te lo rebotan', 'Un cliente te pregunta "¿y ahora qué sigue?" (y no quiere teoría 😅)', 'Y el PJN… bueno, el PJN no perdona distracciones'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-red-50/50 p-5 rounded-2xl border border-red-100" data-id="element-61" data-mp="2pdemeh5kgscr" data-mpi={i}>
                  <div className="bg-red-100 rounded-full p-1.5 flex-shrink-0 mt-0.5" data-id="element-62" data-mp="2ko3yo1mamfsc">
                    <XIcon className="h-5 w-5 text-red-500" data-id="element-63" data-mp="26o2ykodurcdx" />
                  </div>
                  <span className="text-slate-700 font-medium leading-relaxed" data-id="element-64" data-mp="2apegs8uecvc3">
                    {text}
                  </span>
                </div>)}
            </div>
            <div className="mt-10 text-center" data-id="element-65" data-mp="33dacpbc56j7t">
              <p className="inline-block bg-red-50 text-red-700 px-6 py-3 rounded-full text-lg font-bold border border-red-100" data-id="element-66" data-mp="33f4yerv8mfcy">
                No es que no sepas. Es que nadie te dio el paso a paso real.
              </p>
            </div>
          </div>

          <div className="bg-slate-900 text-white rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.3)] p-8 md:p-12 mb-8 border border-slate-800 relative overflow-hidden" data-id="element-67" data-mp="3hcjv8hntlpey">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600" data-id="element-68" data-mp="1ao9qgzek4nnu"></div>
            <div className="absolute -right-20 -top-20 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-69" data-mp="15oezywyp203b"></div>
            <h3 className="text-2xl md:text-4xl font-black mb-8 text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500 uppercase text-center tracking-tight" data-id="element-70" data-mp="1kdksy36xuu2r">
              El problema que nadie dice en voz alta (pero todos viven)
            </h3>
            <p className="text-lg md:text-xl mb-8 text-slate-300 text-center font-light" data-id="element-71" data-mp="mrni8rysvt1d">
              En tu primer año, es normal que pase esto:
            </p>
            <div className="grid md:grid-cols-2 gap-5" data-id="element-72" data-mp="wp1m7s3jepcs">
              {['Tenés conocimiento… pero no tenés sistema', 'Te cuesta saber "qué va primero" y "qué no se toca"', 'Perdés horas buscando modelos (y ninguno coincide)', 'Dudás con requisitos, adjuntos, formatos, presentación', 'Te frena el miedo al error "de principiante"', 'Te agarran casos y sentís que estás corriendo atrás de todo'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-slate-800/50 p-4 rounded-xl border border-slate-700/50" data-id="element-73" data-mp="qmggk0mokc58" data-mpi={i}>
                  <div className="bg-yellow-500/20 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-74" data-mp="10m7d07usx17y">
                    <CheckIcon className="h-4 w-4 text-yellow-400" data-id="element-75" data-mp="15kimghh6p9pn" />
                  </div>
                  <span className="text-slate-200 font-medium" data-id="element-76" data-mp="1abh2rh26a7sw">{text}</span>
                </div>)}
            </div>
            <div className="mt-10 bg-red-500/10 border border-red-500/20 rounded-2xl p-6 text-center" data-id="element-77" data-mp="1edc60r3nyv9b">
              <p className="text-xl md:text-2xl font-bold text-red-400" data-id="element-78" data-mp="1jd8aerg9wope">
                Y lo peor: laburás mucho, avanzás poco, y vivís con la sensación
                de estar siempre atrás.
              </p>
            </div>
          </div>

          {/* → scroll a oferta */}
        </div>
      </section>

      {/* Solution Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-79" data-mp="1ti6v35uhdscq">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-80" data-mp="1khs35nn0hf09"></div>
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-81" data-mp="2c7wllgr7nryu"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-82" data-mp="2v5hecyx3jaoq">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 font-bold text-sm md:text-base px-6 py-2 rounded-full mb-8 uppercase tracking-widest shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-83" data-mp="2v46a6xzqo0x3">
            <span className="animate-pulse" data-id="element-84" data-mp="jinkx8huuj1k">⚖️</span> LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-6xl font-black mb-8 uppercase text-center tracking-tight" data-id="element-85" data-mp="oh79lgnu28xm">
            GUÍA PASO A PASO DE <br data-id="element-86" data-mp="agwge6z1wi9a" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-87" data-mp="ageasjqi0rop">
              PROCURACIÓN JURÍDICA 2026
            </span>{' '}
            <br data-id="element-88" data-mp="l2uvy3ctefd" />
            <span className="text-3xl md:text-4xl text-white" data-id="element-89" data-mp="lmfxnoawixm">+ 6 BONUS</span>
          </h2>
          <p className="text-xl md:text-2xl mb-14 text-slate-300 text-center font-light leading-relaxed max-w-3xl mx-auto" data-id="element-90" data-mp="5kfkgqlm0zln">
            Un sistema práctico para que tus primeros pasos sean claros,
            ordenados y{' '}
            <span className="font-semibold text-white" data-id="element-91" data-mp="3ke50rl2g3rd4">profesionales</span>,
            válido para toda Argentina 🇦🇷
          </p>

          <div className="bg-slate-800/40 backdrop-blur-xl rounded-3xl p-8 md:p-12 mb-14 border border-slate-700/50 shadow-2xl relative overflow-hidden" data-id="element-92" data-mp="3fgmr1sglt842">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-slate-700 via-slate-400 to-slate-700" data-id="element-93" data-mp="3pdhpycgshaiv"></div>
            <h3 className="text-2xl md:text-3xl font-black mb-10 text-white uppercase text-center tracking-wide" data-id="element-94" data-mp="6yqlowwuw9jv">
              Cómo se usa <span className="text-yellow-400" data-id="element-95" data-mp="2xdfglpuq4cf">(en 3 pasos)</span>
            </h3>
            <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-96" data-mp="gwmwfnlvt2hg">
              {[{
              step: '1',
              text: 'Abrís la guía'
            }, {
              step: '2',
              text: 'Elegís el trámite / situación'
            }, {
              step: '3',
              text: 'Aplicás el paso a paso + material listo'
            }].map((item, i) => <div key={i} className="bg-slate-900/80 rounded-2xl p-8 text-center border border-slate-700/50 hover:border-yellow-500/30 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)] group" data-id="element-97" data-mp="1wv3rchdv3gyn" data-mpi={i}>
                  <div className="w-16 h-16 mx-auto bg-slate-800 rounded-full flex items-center justify-center mb-6 border border-slate-600 group-hover:border-yellow-500/50 group-hover:bg-yellow-500/10 transition-colors" data-id="element-98" data-mp="18yg58c1czggm">
                    <span className="text-3xl font-black text-yellow-400" data-id="element-99" data-mp="1iv2tlasw8pne">
                      {item.step}
                    </span>
                  </div>
                  <p className="text-lg md:text-xl font-medium text-slate-200" data-id="element-100" data-mp="2ub9fx7o3wj0c">
                    {item.text}
                  </p>
                </div>)}
            </div>
            <div className="mt-10 inline-block bg-yellow-500/10 border border-yellow-500/20 rounded-full px-8 py-3" data-id="element-101" data-mp="2zc70ts0i3r5j">
              <p className="text-lg md:text-xl font-bold text-yellow-400 text-center" data-id="element-102" data-mp="io62qbeeygfx">
                Sin vueltas. Sin improvisar. Sin perder tiempo.
              </p>
            </div>
          </div>

          {/* → scroll a oferta */}
          <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-103" data-mp="8xbej1hlx6ru">
            QUIERO MI MEGAPACK
          </a>
        </div>
      </section>

      {/* What's Included Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-104" data-mp="1kd9r3fbzuaxt">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-105" data-mp="2c7vtteo964h3"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-106" data-mp="27alvf9ivyih4">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 uppercase text-center" data-id="element-107" data-mp="22fq0o1m9lh0b">
            ¿Qué incluye exactamente?
          </h2>

          <div className="bg-slate-50 rounded-xl shadow-xl p-8 mb-8 border border-slate-200" data-id="element-108" data-mp="1the2nej2jgxu">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-109" data-mp="1oh8i0ib7uup9">
              <StarIcon className="h-8 w-8 text-yellow-500 fill-yellow-500" data-id="element-110" data-mp="1ok4bnug16x7w" />
              <h3 className="text-2xl md:text-3xl font-black text-slate-900 uppercase text-center" data-id="element-111" data-mp="1jix3vvdw1y18">
                Producto principal
              </h3>
            </div>
            <a href="#compra" onClick={scrollToOffer} className="block mb-4" data-id="element-112" data-mp="3dvenmsziqg14">
              <img src="https://cdn.magicpatterns.com/uploads/gN2kG2xBBMWAFKYTTxmgEw/Guia_de_procuracion_juridica_Paso_a_paso.png" alt="Guía Paso a Paso de Procuración Jurídica 2026" className="w-full max-w-xl mx-auto h-auto rounded-lg shadow-lg hover:scale-105 transition-transform duration-300" style={{
              aspectRatio: '1/1',
              objectFit: 'cover'
            }} data-id="element-113" data-mp="38xd5ca9x2kqp" />
            </a>
            <h4 className="text-2xl font-bold text-slate-900 mb-3 text-center" data-id="element-114" data-mp="2yg9hie0fnn8z">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026
            </h4>
            <p className="text-lg text-slate-700 mb-3 text-center" data-id="element-115" data-mp="32jfnrlnjpefg">
              Pensada para noveles abogados que necesitan:
            </p>
            <ul className="space-y-3 text-slate-800 max-w-md mx-auto text-left" data-id="element-116" data-mp="3cg290bjsa7i0">
              <li className="flex items-start gap-3" data-id="element-117" data-mp="mqgzipw9w6mf">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-118" data-mp="mpp6nmu28mzu" />
                <span data-id="element-119" data-mp="ro0clmh8idcs">Orden mental (qué va primero, qué va después)</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-120" data-mp="204qkmjcnm9g">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-121" data-mp="3t7h8j3s243qf" />
                <span data-id="element-122" data-mp="3t9juncq39cpv">Ejecución (no "información para leer algún día")</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-123" data-mp="bx9dwpoxlnru">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-124" data-mp="6zzgonvaw7tg" />
                <span data-id="element-125" data-mp="3ffj599l11226">Una ruta clara para actuar con criterio y rapidez</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="w-full bg-gradient-to-b from-slate-50 via-slate-100 to-slate-50 pt-6 pb-10 px-4 relative overflow-hidden" data-id="element-126" data-mp="3p5vql40o0z9d">
        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-127" data-mp="3ke46ncc0lrs7"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-128" data-mp="2wo04l9eh603b"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-129" data-mp="2ronhqonlst0q">
          <div className="bg-slate-900 rounded-xl p-6 mb-6 text-center border-t-4 border-yellow-500" data-id="element-130" data-mp="177nq9xia4k9s">
            <h2 className="text-3xl md:text-5xl font-black text-yellow-400 uppercase text-center" data-id="element-131" data-mp="1bzxnlylq4mm3">
              🎁 BONUS INCLUIDOS HOY
            </h2>
            <p className="text-xl font-bold text-white mt-2 text-center" data-id="element-132" data-mp="129cjjvna6pvs">
              (sin costo adicional)
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6 text-center border border-slate-200" data-id="element-133" data-mp="1q08hlaibyhbh">
            <p className="text-2xl font-bold text-red-900 uppercase text-center" data-id="element-134" data-mp="1uwp6w819n1q5">
              ⚡ Estos bonos son GRATIS por el día de hoy ⚡
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-135" data-mp="1kz2mx7540jzb">
            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-136" data-mp="1l1osj18fwpew">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-137" data-mp="5hipolry5x8l">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-138" data-mp="l0l9eerk25jk">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-139" data-mp="fznxul11w9r1"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/dmZen66tPjYDX1sotCwXwK/Bonus_1.png" alt="Bonus 1" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-140" data-mp="18pweu9juoo41" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-141" data-mp="uszi5rh1wcf8">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-142" data-mp="3jjijqujgn6z8">
                    ✅ BONUS 1: Introducción – Escritos Judiciales Paso a Paso
                  </h3>
                  <p className="text-slate-700" data-id="element-143" data-mp="1ux9ycidcfq09">
                    Para dejar de armar escritos "a ojo" y entender: estructura,
                    lógica, qué va / qué no va, errores típicos de principiante
                    que te hacen perder tiempo.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-144" data-mp="28rsu4ays7v9l">
                    <span className="text-slate-400 line-through font-bold" data-id="element-145" data-mp="2dosz0ijwarz4">
                      ARS 14.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-146" data-mp="2iqidy9a8npsh">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-147" data-mp="sdsy3b324prm">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-148" data-mp="xajey0morpe3">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-149" data-mp="1vpi6ipi48xfr">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-150" data-mp="24mip2fii81ba"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/vo6eXqb7q1Dns49oikMBZ8/Bonus_2.png" alt="Bonus 2" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-151" data-mp="2ekykguokdwql" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-152" data-mp="32c3wszvaq6w5">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-153" data-mp="2xdahr30d27tv">
                    ✅ BONUS 2: Guía Completa: Cómo Subir un Escrito al Portal
                    del PJN
                  </h3>
                  <p className="text-slate-700" data-id="element-154" data-mp="3lv1gitilr3gk">
                    Para que el PJN no te coma la cabeza: paso a paso claro,
                    checklist previo a subir, cómo evitar trabas comunes,
                    presentación sin pánico.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-155" data-mp="2y71hz7f1u8rf">
                    <span className="text-slate-400 line-through font-bold" data-id="element-156" data-mp="32zl4itvpse8d">
                      ARS 18.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-157" data-mp="2obggdadw7ai7">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-158" data-mp="2j991abxrnebn">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-159" data-mp="2zql6t9aux281">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-160" data-mp="2ptyoar606n96">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-161" data-mp="2grz2llk1muzw"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/xw4C8Bo7tFvuqQ8dBb9i9d/Bonus_3.png" alt="Bonus 3" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-162" data-mp="270l1588j7l44" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-163" data-mp="1t2o1u42p10lr">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-164" data-mp="8ju8xi1pbsh4">
                    ✅ BONUS 3: Guía Práctica de Honorarios Profesionales
                    (Argentina)
                  </h3>
                  <p className="text-slate-700" data-id="element-165" data-mp="hl1ur0n170ub">
                    Para que no te pase el clásico: "¿Cuánto cobro?" → silencio
                    incómodo. Acá tenés criterio para presupuestar y cobrar sin
                    regalarte.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-166" data-mp="3pzagbor4yrcz">
                    <span className="text-slate-400 line-through font-bold" data-id="element-167" data-mp="3uyn54f1ki8i7">
                      ARS 16.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-168" data-mp="3l97jfapr2r3">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-169" data-mp="2h0ovcxqzskuv">
            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-170" data-mp="2lyqbb9t4g424">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-171" data-mp="2lxyp2plezioi">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-172" data-mp="1y8vyutcpshie">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-173" data-mp="1ob9j64nlclxd"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/r3X8EagC5xJm8b4HKhFQbT/Bonus_4.png" alt="Bonus 4" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-174" data-mp="1t800evb4tnkd" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-175" data-mp="10pfl4whs2fet">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-176" data-mp="vq2t7xc1ui5d">
                    ✅ BONUS 4: Guía Práctica: Tu Primera Entrevista con
                    Clientes
                  </h3>
                  <p className="text-slate-700" data-id="element-177" data-mp="1jlxa5658s17d">
                    Para que la entrevista no sea un caos: qué preguntar, cómo
                    ordenar el caso, cómo transmitir seguridad sin humo, cómo
                    salir con próximos pasos claros.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-178" data-mp="1od6x1yzeoqfk">
                    <span className="text-slate-400 line-through font-bold" data-id="element-179" data-mp="1of9wf9mg7vwy">
                      ARS 12.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-180" data-mp="1xedh2i19kjdk">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-181" data-mp="zx663beof2d9">
              <div className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_35px_rgba(234,179,8,0.25)] hover:-translate-y-1 transition-all duration-300 border border-slate-200 hover:border-yellow-400/60 overflow-hidden group" data-id="element-182" data-mp="13zuejhzha79p">
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-183" data-mp="1ip8nwq320op3">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-184" data-mp="1rqpy5rts5w5v"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/aP8hCyUAzELr5zghVNRPmQ/Bonus_5.png" alt="Bonus 5" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-185" data-mp="3pikk3qnhm31q" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-186" data-mp="3h60ndvc4koyo">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-187" data-mp="3c9a8hbc23zeu">
                    ✅ BONUS 5: Pasos Previos al Ejercicio Profesional
                  </h3>
                  <p className="text-slate-700" data-id="element-188" data-mp="8pxpuieq8go2">
                    Checklist para empezar bien: orden básico, preparación
                    práctica, prevención de errores por apuro.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-189" data-mp="3vykn0m02gebd">
                    <span className="text-slate-400 line-through font-bold" data-id="element-190" data-mp="3qzrb2y0fgvdb">
                      ARS 10.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-191" data-mp="2firmodh7b0ok">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-192" data-mp="c2cw0myr63gu">
              <div className="bg-white rounded-2xl shadow-[0_0_30px_rgba(234,179,8,0.25)] hover:shadow-[0_0_45px_rgba(234,179,8,0.4)] hover:-translate-y-1 transition-all duration-300 border-2 border-yellow-500 overflow-hidden group relative" data-id="element-193" data-mp="3ug2mhqaac3uf">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-300 via-amber-500 to-yellow-300 z-20" data-id="element-194" data-mp="uz4belb6byfm"></div>
                <div className="w-full relative" style={{
                aspectRatio: '1/1'
              }} data-id="element-195" data-mp="gyti7bme67ra">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-196" data-mp="31pas8ycs5p9q"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/m4unkkyeQbYhT7YdQ3UiF8/Bonus_6.png" alt="Bonus 6" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-197" data-mp="2y7wjs8iam1xx" />
                </div>
                <div className="p-6 text-center relative bg-white" data-id="element-198" data-mp="33795ur1cb4zg">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center group-hover:text-amber-600 transition-colors" data-id="element-199" data-mp="334woaezhuwmx">
                    ✅ BONUS 6: GRUPO DE WHATSAPP (+714 colegas)
                  </h3>
                  <p className="text-slate-700" data-id="element-200" data-mp="2p783161ilnhc">
                    Cuando aparece esa duda que te frena: entrás, preguntás,
                    destrabás y seguís. Además tenés bolsa de trabajo con
                    ofertas laborales de estudios jurídicos de todo el país.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2" data-id="element-201" data-mp="1rrua1qkvaj5x">
                    <span className="text-slate-400 line-through font-bold" data-id="element-202" data-mp="1rpq658myxk5n">
                      ARS 24.990
                    </span>
                    <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full border border-green-300" data-id="element-203" data-mp="n94ycg9jgos">
                      HOY GRATIS
                    </span>
                  </div>
                  <div className="mt-3 flex items-center justify-center gap-2 text-green-600 font-semibold" data-id="element-204" data-mp="9f1cae9zq9p5">
                    <UsersIcon className="h-5 w-5" data-id="element-205" data-mp="38wj5p12nz5ii" />
                    <span data-id="element-206" data-mp="3duaxzw780tn8">Comunidad activa</span>
                  </div>
                </div>
              </div>
            </a>
          </div>

          {/* Bonuses savings summary */}
          <div className="mt-10 max-w-3xl mx-auto bg-slate-900 rounded-3xl p-8 md:p-10 text-center border-2 border-green-500 shadow-[0_0_40px_rgba(34,197,94,0.2)] relative overflow-hidden" data-id="element-207" data-mp="3hy8wc4oq20f8">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-208" data-mp="x7rngla2koyd"></div>
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-32 bg-green-500/20 rounded-full blur-3xl pointer-events-none" data-id="element-209" data-mp="1c8fafarolnlp"></div>
            <p className="text-sm md:text-base font-bold uppercase tracking-widest text-green-400 mb-3 relative z-10" data-id="element-210" data-mp="17a5daumeccxg">
              💰 Solo en bonus te estás llevando GRATIS
            </p>
            <div className="flex items-center justify-center gap-3 mb-3 relative z-10" data-id="element-211" data-mp="ygijvb5nvlrf">
              <span className="text-2xl md:text-3xl text-slate-500 line-through font-bold" data-id="element-212" data-mp="tj8lv747i1rz">
                ARS 98.940
              </span>
            </div>
            <p className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-300 via-green-400 to-green-500 leading-none mb-4 relative z-10 drop-shadow-[0_0_20px_rgba(34,197,94,0.3)]" data-id="element-213" data-mp="jk1a2od4ef6z">
              ARS 0
            </p>
            <p className="inline-block bg-green-500/10 border border-green-500/30 text-green-300 font-black text-lg md:text-2xl px-6 py-3 rounded-2xl relative z-10" data-id="element-214" data-mp="2dxipfo3dg5qx">
              ✅ Ahorrás ARS 98.940 en bonus — solo por hoy
            </p>
            <p className="text-sm text-slate-400 mt-4 relative z-10" data-id="element-215" data-mp="2x6slk3b53pm9">
              6 bonus valuados en ARS 98.940, incluidos sin costo adicional con
              tu MegaPack.
            </p>
          </div>
        </div>
      </section>

      {/* Before/After Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-216" data-mp="2ocnrzc4mg031">
        <div className="absolute top-1/2 left-0 w-64 h-64 bg-red-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-217" data-mp="2egax4axcbg6p"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-green-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-218" data-mp="20h2v7a9sltyt"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-219" data-mp="25gns7f5ejs8w">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-8 text-center uppercase" data-id="element-220" data-mp="3uukkp2trd0wh">
            ⚔️ Antes vs Después
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-221" data-mp="3myd4z3x4eac">
            <div className="bg-red-50 rounded-3xl shadow-[0_0_40px_rgba(220,38,38,0.15)] p-8 border-2 border-red-300 relative overflow-hidden" data-id="element-222" data-mp="dry9d4regbq2">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-300 via-red-500 to-red-300" data-id="element-223" data-mp="8uehh21s40fn"></div>
              <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-red-400/20 rounded-full blur-3xl" data-id="element-224" data-mp="mmmdusp5hpdt"></div>
              <h3 className="text-2xl font-black text-red-800 mb-6 uppercase text-center relative z-10" data-id="element-225" data-mp="hryl2hn468tf">
                Antes (primer año modo supervivencia)
              </h3>
              <div className="space-y-4" data-id="element-226" data-mp="rjct5dt4sgy6">
                <div className="flex items-start gap-3" data-id="element-227" data-mp="15j41axwyv349">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-228" data-mp="15iksq7t7hr2w" />
                  <span className="text-slate-800" data-id="element-229" data-mp="11j3nnfhoyvy9">Dudas constantes</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-230" data-mp="37big3o47rrgg">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-231" data-mp="339f32v1wcet2" />
                  <span className="text-slate-800" data-id="element-232" data-mp="33bi387wrjobi">
                    Horas perdidas buscando modelos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-233" data-mp="1dk536u75thl6">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-234" data-mp="1riwd04ezoh3i" />
                  <span className="text-slate-800" data-id="element-235" data-mp="1rgryytndm1pi">
                    Miedo a errores "tontos"
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-236" data-mp="21git2u80yep2">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-237" data-mp="21ezcf2igi1mr" />
                  <span className="text-slate-800" data-id="element-238" data-mp="1whfzc5xhvuwe">Honorarios a ojo</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-239" data-mp="2b6c67zntf1vf">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-240" data-mp="2680sveyba98g" />
                  <span className="text-slate-800" data-id="element-241" data-mp="26a50o7zbzse0">
                    Entrevistas sin estructura
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-242" data-mp="2f9i86v3wa6w3">
                  <XIcon className="h-6 w-6 text-red-700 flex-shrink-0 mt-1" data-id="element-243" data-mp="2yu9048hgpvqm" />
                  <span className="text-slate-800" data-id="element-244" data-mp="2ys5zyvmlim86">
                    Sensación de "me falta algo"
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-3xl shadow-[0_0_40px_rgba(34,197,94,0.15)] p-8 border-2 border-green-500 relative overflow-hidden" data-id="element-245" data-mp="2pt17a5xptn3x">
              <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-300 via-green-500 to-green-300" data-id="element-246" data-mp="2g40zpy55dje4"></div>
              <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-green-400/20 rounded-full blur-3xl" data-id="element-247" data-mp="2kvj12nb31lzm"></div>
              <h3 className="text-2xl font-black text-green-800 mb-6 uppercase text-center relative z-10" data-id="element-248" data-mp="26767fwzgwf8a">
                Después (primer año con sistema)
              </h3>
              <div className="space-y-4" data-id="element-249" data-mp="1x5y7zbl7t8cm">
                <div className="flex items-start gap-3" data-id="element-250" data-mp="1x6zuqdblfja6">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-251" data-mp="222yd9ka8q72o" />
                  <span className="text-slate-800" data-id="element-252" data-mp="7ob0ett7a368">
                    Pasos claros y ordenados
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-253" data-mp="2vqbo6p5ig9k">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-254" data-mp="3u2kr59klrna6" />
                  <span className="text-slate-800" data-id="element-255" data-mp="3q20qvx4qg3jt">
                    Material listo para aplicar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-256" data-mp="qm3wbc5epcu4">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-257" data-mp="ln12knuvmt1g" />
                  <span className="text-slate-800" data-id="element-258" data-mp="hlp7w3x5bhme">
                    Más seguridad al presentar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-259" data-mp="cm2vfwp565en">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-260" data-mp="32bwsq5abcw07" />
                  <span className="text-slate-800" data-id="element-261" data-mp="2xd3c43zqcovt">Menos tiempo perdido</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-262" data-mp="1cv17e7q0ac7f">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-263" data-mp="1cwm1xxcblv5a" />
                  <span className="text-slate-800" data-id="element-264" data-mp="1hv72jxvhigu9">
                    Honorarios con criterio
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-265" data-mp="1ltmp60nnln75">
                  <CheckIcon className="h-6 w-6 text-green-700 flex-shrink-0 mt-1" data-id="element-266" data-mp="1qnhblbun8g9x" />
                  <span className="text-slate-800" data-id="element-267" data-mp="1vmbtmbkse0sz">
                    Entrevistas que terminan en "siguiente paso"
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Today Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black text-white py-12 px-4 border-t-4 border-yellow-500 relative overflow-hidden" data-id="element-268" data-mp="29l1vs5mgqqo7">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-yellow-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-269" data-mp="f6irpym9wf42"></div>
        <div className="max-w-5xl mx-auto relative z-10" data-id="element-270" data-mp="3c16lofg9p2j1">
          <div className="text-center mb-12" data-id="element-271" data-mp="3c0n2kvevs83f">
            <h2 className="text-4xl md:text-6xl font-black uppercase text-yellow-400 drop-shadow-lg mb-4" data-id="element-272" data-mp="3q0fsioil2kac">
              🧾 Todo lo que te llevás hoy
            </h2>
            <p className="text-xl text-slate-300 font-medium" data-id="element-273" data-mp="3kzi6g0ugd63k">
              Un sistema completo diseñado para que no tengas que improvisar
              nunca más.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-274" data-mp="2saujm0u228nw">
            {[{
            title: 'Guía Paso a Paso 2026',
            desc: 'El sistema central de procuración jurídica argentina.',
            icon: AwardIcon
          }, {
            title: 'Bonus 1: Escritos Judiciales',
            desc: 'Modelos y estructuras listas para usar.',
            icon: DownloadIcon
          }, {
            title: 'Bonus 2: Portal PJN',
            desc: 'Guía técnica para no trabarte nunca al subir escritos.',
            icon: ZapIcon
          }, {
            title: 'Bonus 3: Honorarios Prof.',
            desc: 'Criterios reales para cobrar lo que corresponde.',
            icon: ShieldIcon
          }, {
            title: 'Bonus 4: Primera Entrevista',
            desc: 'Cómo cerrar clientes y transmitir seguridad.',
            icon: UsersIcon
          }, {
            title: 'Bonus 5: Pasos Previos',
            desc: 'Checklist indispensable antes de empezar a ejercer.',
            icon: ClockIcon
          }, {
            title: 'Bonus 6: Grupo WhatsApp',
            desc: 'Acceso a +714 colegas y bolsa de trabajo en tiempo real.',
            icon: UsersIcon
          }, {
            title: 'Acceso de por vida',
            desc: 'Descarga digital inmediata y actualizaciones gratis.',
            icon: ZapIcon
          }].map((item, i) => <div key={i} className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 flex items-start gap-4 hover:bg-slate-800 hover:border-yellow-500/50 hover:shadow-[0_0_25px_rgba(234,179,8,0.15)] transition-all duration-300 group relative overflow-hidden" data-id="element-275" data-mp="1kcz2y0en26lb" data-mpi={i}>
                <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-276" data-mp="16cobow9f2pzm"></div>
                <div className="bg-yellow-400/10 rounded-xl p-3 group-hover:bg-yellow-400/20 transition-colors relative z-10 shadow-[0_0_15px_rgba(234,179,8,0.1)] group-hover:shadow-[0_0_20px_rgba(234,179,8,0.3)]" data-id="element-277" data-mp="xdb1u2hdrzed">
                  <item.icon className="h-6 w-6 text-yellow-400" data-id="element-278" data-mp="2rqsqxtxfp4bi" />
                </div>
                <div data-id="element-279" data-mp="djt75m93e6y6">
                  <h3 className="text-xl font-bold text-white mb-1 group-hover:text-yellow-400 transition-colors" data-id="element-280" data-mp="di8drzyiku1w">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-281" data-mp="n9ct50s3qgx9">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-2xl p-1 shadow-2xl" data-id="element-282" data-mp="3qq32npmw7c3p">
            <div className="bg-slate-900 rounded-[14px] py-6 px-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-283" data-mp="3voeci0d6tmlx">
              <div className="flex items-center gap-4" data-id="element-284" data-mp="3kc47cl8675w">
                <div className="bg-green-500/20 rounded-full p-3" data-id="element-285" data-mp="8jyhfm11znep">
                  <CheckIcon className="h-8 w-8 text-green-500" data-id="element-286" data-mp="8i3szxqkpd5v" />
                </div>
                <div data-id="element-287" data-mp="1f00qe1qnn25n">
                  <p className="text-white font-black text-xl md:text-2xl uppercase italic" data-id="element-288" data-mp="1f2mvluq2p5kp">
                    ¡Acceso inmediato garantizado!
                  </p>
                  <p className="text-slate-400 text-sm" data-id="element-289" data-mp="vnbcl7ibx0iq">
                    Recibís todo el material en tu email apenas confirmás el
                    pago.
                  </p>
                </div>
              </div>
              <div className="flex -space-x-3" data-id="element-290" data-mp="14h7yqmbhucy5">
                {[1, 2, 3, 4, 5].map(n => <div key={n} className="h-10 w-10 rounded-full border-2 border-slate-900 bg-slate-700 flex items-center justify-center text-[10px] font-bold" data-id="element-291" data-mp="zmadmh0xwd4w">
                    {n}⭐
                  </div>)}
                <div className="h-10 px-4 rounded-full border-2 border-slate-900 bg-yellow-500 text-black flex items-center justify-center text-xs font-black" data-id="element-292" data-mp="1nd6ee3ndiioa">
                  +714 COLEGAS
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Preview Carousel */}
      <ProductPreviewCarousel data-id="element-293" data-mp="3azsldoasoslb" />

      {/* Authority / Trust Section — who we are */}
      <section className="w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black text-white py-16 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-294" data-mp="3b26evspttwqr">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-72 bg-yellow-500/8 rounded-full blur-[100px] pointer-events-none" data-id="element-295" data-mp="3693uob6xvzn8"></div>
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-296" data-mp="2rb1mfnoyqpzn"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-297" data-mp="gjs2zpubkzm9">
          <div className="text-center mb-12" data-id="element-298" data-mp="gkb9maeis1kz">
            <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 font-bold text-sm px-6 py-2 rounded-full mb-6 uppercase tracking-widest shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-299" data-mp="lil7wtvjjiat">
              <AwardIcon className="h-4 w-4" data-id="element-300" data-mp="1sanc6xsim5b3" /> Trayectoria y confianza
            </div>
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-301" data-mp="1x8f3bplc5ne8">
              Hecho por la comunidad de abogados más grande de Argentina
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl mx-auto font-light" data-id="element-302" data-mp="2az21ngn6pb9s">
              Somos la comunidad creadora de soluciones para abogados y
              estudiantes de abogacía{' '}
              <span className="text-white font-semibold" data-id="element-303" data-mp="2kxrdarohlzhl">
                más importante del país
              </span>
              . Este MegaPack no lo armó cualquiera: lo construimos entre
              profesionales que viven lo mismo que vos.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-304" data-mp="33vjpq2zbvuzo">
            {/* Instagram proof screenshot */}
            <div className="flex justify-center" data-id="element-305" data-mp="2z28gxwayh454">
              <div className="relative group max-w-[300px]" data-id="element-306" data-mp="2v1ybckr2sfqs">
                <div className="absolute inset-0 bg-yellow-500/15 rounded-[2rem] blur-2xl group-hover:bg-yellow-500/25 transition-all duration-500" data-id="element-307" data-mp="2v2g3p6ama9tf"></div>
                <div className="relative bg-slate-900/80 backdrop-blur-xl rounded-[2rem] border border-yellow-500/30 p-2.5 shadow-[0_0_40px_rgba(234,179,8,0.15)] overflow-hidden" data-id="element-308" data-mp="3mtnnk19rm7m6">
                  <img src="https://cdn.magicpatterns.com/uploads/izoafXB3EzoUwuxyggz4Dw/image.png" alt="Perfil verificado de la comunidad Estudiantes de Abogacía Argentina con 33.1 mil seguidores" className="w-full h-auto rounded-[1.5rem]" data-id="element-309" data-mp="3dsfovi3c74rk" />
                </div>
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white text-xs font-black px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap border border-blue-300/40" data-id="element-310" data-mp="1xdo9c5rahrzo">
                  ✓ Cuenta verificada
                </div>
              </div>
            </div>

            {/* Stats + scarcity */}
            <div className="space-y-6" data-id="element-311" data-mp="1px9itzm5f61x">
              <div className="grid grid-cols-2 gap-4" data-id="element-312" data-mp="1ut8e875w9obu">
                <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-6 text-center" data-id="element-313" data-mp="1uw489kemfsv0">
                  <p className="md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-br from-yellow-200 to-yellow-500 text-[30px]" data-id="element-314" data-mp="1g3aj179jryd5">
                    +33.100
                  </p>
                  <p className="text-sm text-slate-400 font-medium mt-1" data-id="element-315" data-mp="172m6kgzsy62d">
                    profesionales de todo Argentina
                  </p>
                </div>
                <div className="bg-slate-800/50 border border-green-500/30 rounded-2xl p-6 text-center shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-316" data-mp="x6rgj0t918pk">
                  <p className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-300 to-green-500" data-id="element-317" data-mp="ijkbtcucx6z4">
                    714
                  </p>
                  <p className="text-sm text-slate-400 font-medium mt-1" data-id="element-318" data-mp="dmtxaty7ajft">
                    con acceso al grupo privado
                  </p>
                </div>
              </div>

              <div className="bg-green-500/10 border border-green-500/30 rounded-2xl p-6 shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-319" data-mp="nkqb5tiivshm">
                <p className="text-base md:text-lg text-green-200 font-bold leading-relaxed" data-id="element-320" data-mp="wjlduvmcykg6">
                  🔒 De más de <span className="text-white" data-id="element-321" data-mp="1b8rb4e1my0lf">33.100</span>{' '}
                  miembros, solo <span className="text-green-300" data-id="element-322" data-mp="1694ya5ppymd5">714</span>{' '}
                  tienen el privilegio de interactuar a diario en el grupo
                  privado de WhatsApp — y hoy podés ser uno de ellos al realizar
                  tu compra.
                </p>
              </div>

              {/* Trust pillars */}
              <div className="grid grid-cols-3 gap-3" data-id="element-323" data-mp="39qth8wvmkhd9">
                {[{
                icon: AwardIcon,
                label: 'Trayectoria'
              }, {
                icon: ShieldIcon,
                label: 'Seguridad'
              }, {
                icon: CheckIcon,
                label: 'Transparencia'
              }].map((p, i) => <div key={i} className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-4 flex flex-col items-center gap-2 text-center" data-id="element-324" data-mp="2vq8y1zlssjj8" data-mpi={i}>
                    <p.icon className="h-6 w-6 text-yellow-400" data-id="element-325" data-mp="34qoz72f2jekx" />
                    <span className="text-xs md:text-sm font-bold text-slate-200" data-id="element-326" data-mp="34oubjgcex8d5">
                      {p.label}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section — desire + urgency before the offer */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-16 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-327" data-mp="20hf3rhxkvdi9">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-green-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-328" data-mp="1qrvk4a21jfmc"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-yellow-500/8 rounded-full blur-[100px] pointer-events-none" data-id="element-329" data-mp="1lt22q6jmv4gw"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-330" data-mp="1gvaepnm402hz">
          <div className="text-center mb-12" data-id="element-331" data-mp="1csm1z4u9ybfq">
            <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/30 text-green-400 font-bold text-sm px-6 py-2 rounded-full mb-6 uppercase tracking-widest shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-332" data-mp="1ctfcmgwctl35">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-333" data-mp="325zehhcjj5rx"></span>
              Comunidad activa
            </div>
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-334" data-mp="3l9kpd72dhy35">
              La red de abogados más importante de Argentina
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl mx-auto font-light" data-id="element-335" data-mp="3ha22i5qzrcxo">
              Ya somos más de{' '}
              <span className="text-green-400 font-black" data-id="element-336" data-mp="8rw9vudl2lbh">714 colegas</span>,
              noveles abogados y estudiantes de derecho de toda la República
              Argentina resolviendo problemas, consiguiendo trabajo y pidiendo
              ayuda. No comprás solo un material: entrás a una red que te
              respalda{' '}
              <span className="text-white font-semibold" data-id="element-337" data-mp="2jlijuts1vudj">todos los días</span>.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-338" data-mp="2olwgzgs45jws">
            {/* Community card image */}
            <div className="relative group" data-id="element-339" data-mp="2h0101nwpv5pi">
              <div className="absolute inset-0 bg-green-500/15 rounded-3xl blur-2xl group-hover:bg-green-500/25 transition-all duration-500" data-id="element-340" data-mp="2c29b92rdbzpj"></div>
              <div className="relative bg-slate-900/80 backdrop-blur-xl rounded-3xl border border-green-500/30 p-4 shadow-[0_0_40px_rgba(34,197,94,0.15)] overflow-hidden" data-id="element-341" data-mp="2q0z4g7b2hf8m">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-342" data-mp="1xcuz5mwer46g"></div>
                <img src="https://cdn.magicpatterns.com/uploads/dMA9u4fFe9VicheKNfNZuH/image.png" alt="Grupo de WhatsApp Abogados y Estudiantes de Abogacía Argentina — 714 miembros" className="w-full h-auto rounded-2xl" data-id="element-343" data-mp="1td2maxzzebva" />
                <div className="mt-4 flex items-center justify-center gap-3 pb-2" data-id="element-344" data-mp="1eltuci8lweez">
                  <div className="flex -space-x-2" data-id="element-345" data-mp="19ok635wye8sq">
                    {[1, 2, 3, 4].map(n => <div key={n} className="h-8 w-8 rounded-full border-2 border-slate-900 bg-slate-700 flex items-center justify-center text-[9px] font-bold" data-id="element-346" data-mp="p2qktg14jx4d">
                        {n}⭐
                      </div>)}
                  </div>
                  <p className="text-sm text-slate-300 font-semibold" data-id="element-347" data-mp="13319qdivj1mw">
                    <span className="text-green-400 font-black" data-id="element-348" data-mp="17zrrd5abu5af">+714</span>{' '}
                    colegas ya adentro
                  </p>
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="space-y-4" data-id="element-349" data-mp="1gtwm3zsl00v8">
              {[{
              icon: ZapIcon,
              title: 'Soporte en vivo todos los días',
              desc: 'Tirás tu duda y destrabás el caso en minutos, no en semanas.'
            }, {
              icon: UsersIcon,
              title: 'Red de contactos en todas las provincias',
              desc: 'Colegas de toda Argentina listos para ayudarte con averiguaciones y trámites locales.'
            }, {
              icon: ShieldIcon,
              title: 'Soluciones casi inmediatas',
              desc: 'Ante una inseguridad o situación complicada en un caso, nunca estás solo.'
            }, {
              icon: BriefcaseIcon,
              title: 'Bolsa de trabajo exclusiva',
              desc: 'Estudios jurídicos de todo el país nos envían sus ofertas laborales y las publicamos en el grupo de WhatsApp.'
            }, {
              icon: AwardIcon,
              title: 'Networking que vale oro',
              desc: 'Contactos, derivaciones y oportunidades reales que esta red genera todos los días.'
            }].map((item, i) => <div key={i} className="flex items-start gap-4 bg-slate-800/40 backdrop-blur-md border border-slate-700/50 rounded-2xl p-5 hover:border-green-500/40 hover:bg-slate-800/60 transition-all duration-300" data-id="element-350" data-mp="grzwp5jxrdby" data-mpi={i}>
                  <div className="bg-green-500/15 rounded-xl p-3 flex-shrink-0 shadow-[0_0_15px_rgba(34,197,94,0.1)]" data-id="element-351" data-mp="1yei4rjoeurn6">
                    <item.icon className="h-6 w-6 text-green-400" data-id="element-352" data-mp="1tfyifi5wndua" />
                  </div>
                  <div data-id="element-353" data-mp="2q3cxpbztp4qq">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-354" data-mp="2q6qy4eoxf3vj">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-400 leading-relaxed" data-id="element-355" data-mp="2hc2vyxene2ay">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Urgency + value line */}
          <div className="mt-12 bg-red-500/10 border border-red-500/30 rounded-2xl p-6 text-center max-w-3xl mx-auto" data-id="element-356" data-mp="39uqatv31wl3l">
            <p className="text-lg md:text-xl font-bold text-red-300" data-id="element-357" data-mp="3cd1rwiwu29df">
              ⚠️ El acceso a la comunidad está incluido solo dentro de la oferta
              de hoy. Esta red de contactos ya de por sí es invaluable — y
              merecés formar parte de ella.
            </p>
          </div>

          <div className="flex justify-center mt-8" data-id="element-358" data-mp="3qcusd5y5w3yl">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 uppercase text-center border-2 border-green-400" data-id="element-359" data-mp="3qdmelq5vcpc7">
              QUIERO ENTRAR A LA COMUNIDAD
            </a>
          </div>
        </div>
      </section>

      {/* Urgency Module — right before the offer */}
      <UrgencyModule data-id="element-360" data-mp="mx5qebl6hd54" />

      {/* Pricing Section — CHECKOUT DIRECTO */}
      <section id="compra" className="w-full bg-[#f8fafc] py-14 px-4 relative overflow-hidden" data-id="element-361" data-mp="2iyzchmz72dlx">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" data-id="element-362" data-mp="2eyoxxlxc6evg"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-yellow-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-363" data-mp="2sqn35lnxfqmc"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-364" data-mp="32m6r9lw91l0j">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-sm px-6 py-2.5 rounded-full mb-8 uppercase tracking-widest shadow-[0_0_20px_rgba(220,38,38,0.3)] animate-pulse" data-id="element-365" data-mp="2xndejvosdy1f">
            🔥 Oferta por tiempo limitado
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-4 uppercase text-center tracking-tight" data-id="element-366" data-mp="1h9di4up5gqix">
            Invertí en tu carrera hoy
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 mb-12 text-center font-light" data-id="element-367" data-mp="1cd6mbuqgwvep">
            Todo lo que necesitás para ejercer con{' '}
            <span className="font-bold text-slate-900" data-id="element-368" data-mp="3sxifqm1r0rxq">seguridad</span> desde el
            día 1
          </p>

          <div className="bg-white rounded-[2.5rem] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1),0_0_40px_rgba(234,179,8,0.15)] overflow-hidden border border-slate-100 mb-10 relative" data-id="element-369" data-mp="3f52gzxfvrg2m">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400" data-id="element-370" data-mp="357ejx0usxwha"></div>
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-yellow-50/50 via-white to-white opacity-100 pointer-events-none" data-id="element-371" data-mp="3a8c1pcbwgoi9"></div>

            {/* Top ribbon */}
            <div className="bg-slate-900 py-4 px-6 relative z-10 shadow-md" data-id="element-372" data-mp="ufmuhenp2dis">
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 font-black text-lg md:text-xl uppercase text-center tracking-widest" data-id="element-373" data-mp="udihm77ti46d">
                ⚖️ Oferta especial — Guía + 6 Bonus incluidos ⚖️
              </p>
            </div>

            <div className="p-8 md:p-12 relative z-10" data-id="element-374" data-mp="4s8yuupsj6fg">
              {/* Price comparison */}
              <div className="mb-8" data-id="element-375" data-mp="3vvxnodwyt3i8">
                <p className="text-xl md:text-2xl line-through mb-2 text-center font-medium text-[#E10A14]" data-id="element-376" data-mp="3qypdazi263rj">
                  Precio regular: ARS 87.500
                </p>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-377" data-mp="3mz6x2h16mgv1">
                  <span className="text-2xl md:text-3xl font-black text-slate-800 uppercase tracking-tight" data-id="element-378" data-mp="3i4sxe2fhlnkk">
                    Hoy solo:
                  </span>
                </div>
                <p className="md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-br from-green-500 to-green-700 text-center drop-shadow-sm text-[48px]" data-id="element-379" data-mp="389itf95j3645">
                  ARS 34.999
                </p>
              </div>

              {/* Savings badge */}
              <div className="flex justify-center mb-8" data-id="element-380" data-mp="1eq0dx412upb0">
                <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 font-black text-xl md:text-2xl px-8 py-3 rounded-2xl shadow-sm" data-id="element-381" data-mp="1erjt0razyub7">
                  Ahorrás: ARS 52.500
                </div>
              </div>

              {/* Benefits grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-382" data-mp="1sn5rdp34eqga">
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-383" data-mp="v2t13anl1rz1">
                  <ZapIcon className="h-7 w-7 text-yellow-500 mx-auto mb-2" data-id="element-384" data-mp="101cmn9y9l1qv" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-385" data-mp="14ze1fionqewj">
                    Acceso inmediato
                  </p>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-386" data-mp="19sh1m9nxwmlp">
                  <DownloadIcon className="h-7 w-7 text-slate-700 mx-auto mb-2" data-id="element-387" data-mp="c8w46yam77r1" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-388" data-mp="h8ih16mj6lzb">
                    Descarga digital
                  </p>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-389" data-mp="581xw62j87nt">
                  <ClockIcon className="h-7 w-7 text-slate-700 mx-auto mb-2" data-id="element-390" data-mp="iyxde17jdn0d" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-391" data-mp="j11eychyq9xh">
                    Acceso de por vida
                  </p>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 text-center border border-slate-200" data-id="element-392" data-mp="3mgyqaorv1nxe">
                  <ShieldIcon className="h-7 w-7 text-green-600 mx-auto mb-2" data-id="element-393" data-mp="3ifdihhu6nzu2" />
                  <p className="text-sm font-bold text-slate-800" data-id="element-394" data-mp="98kser5qio6">
                    Garantía 7 días
                  </p>
                </div>
              </div>

              {/* WhatsApp community callout */}
              <div className="bg-green-50 border border-green-300 rounded-xl p-4 mb-8 flex items-center justify-center gap-3" data-id="element-395" data-mp="1bn2v0f3amvvz">
                <UsersIcon className="h-6 w-6 text-green-700 flex-shrink-0" data-id="element-396" data-mp="16o9lsyv1hr1m" />
                <p className="text-sm md:text-base text-green-900 font-bold text-center" data-id="element-397" data-mp="2olcu7f4j3cir">
                  La comunidad de WhatsApp más grande de abogados y estudiantes
                  de abogacía te está esperando 🇦🇷
                </p>
              </div>

              {/* Installments — small standout pill right above CTA */}
              <div className="flex justify-center mb-4" data-id="element-398" data-mp="2kmx2wz1ezhzj">
                <div className="inline-flex items-center gap-1.5 bg-green-50 border border-green-300 rounded-full py-1.5 px-4 shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-399" data-mp="38bg9990wlkoz">
                  <p className="text-xs md:text-sm font-bold text-slate-700 text-center" data-id="element-400" data-mp="2yktzhvfvboe7">
                    💳 Pagá en hasta{' '}
                    <span className="text-green-600 font-black" data-id="element-401" data-mp="33in78swtkqgl">3 cuotas</span>{' '}
                    — Acceso inmediato
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <div className="flex justify-center mb-4 relative z-10" data-id="element-402" data-mp="3w1ix1cxsc4hs">
                <a href="https://megapacknovelesabogados.impultienda.ar/" className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-3xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_50px_rgba(34,197,94,0.6)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-403" data-mp="1vy01u0p3io9m">
                  QUIERO ACCEDER AHORA + 7 DIAS DE GARANTIA ⭐
                </a>
              </div>

              {/* Payment & security badges */}
              <div className="flex justify-center mb-4" data-id="element-404" data-mp="24x3h0tl56jiu">
                <img src="https://cdn.magicpatterns.com/uploads/na8BuWPBQNjFajZ2AV1MpB/pasted-image.jpg" alt="Mercado Pago, VISA, Mastercard — Compra 100% segura, SSL certificado" className="w-full max-w-xs h-auto rounded-2xl border border-slate-200 shadow-sm" data-id="element-405" data-mp="20x345ddoygdw" />
              </div>

              <p className="text-base font-bold text-slate-700 text-center" data-id="element-406" data-mp="316kpggq54393">
                ✔ Válido para toda Argentina 🇦🇷
              </p>
            </div>
          </div>

          {/* Guarantee */}
          <div className="max-w-2xl mx-auto bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black rounded-3xl px-8 py-12 md:px-12 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.4)] border border-slate-800 relative overflow-hidden" data-id="element-407" data-mp="3a4d6bpbifiyl">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-72 h-40 bg-green-500/15 rounded-full blur-3xl pointer-events-none" data-id="element-408" data-mp="3otj3l7qsez3u"></div>

            {/* Shield */}
            <div className="flex justify-center mb-6 relative z-10" data-id="element-409" data-mp="1qeacnojfxl3">
              <div className="relative" data-id="element-410" data-mp="1nicezcox8wn">
                <div className="absolute inset-0 bg-green-500/30 rounded-full blur-2xl scale-150" data-id="element-411" data-mp="1yiy07fvkm6ev"></div>
                <div className="relative w-24 h-24 rounded-2xl bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center shadow-[0_0_30px_rgba(34,197,94,0.5)] border border-green-300/40" data-id="element-412" data-mp="23gg1ck3cjhcb">
                  <ShieldIcon className="h-12 w-12 text-white drop-shadow-lg" data-id="element-413" data-mp="1tuj83r45n85w" />
                </div>
              </div>
            </div>

            {/* Heading */}
            <h3 className="text-2xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 uppercase text-center tracking-tight mb-8 drop-shadow-[0_0_15px_rgba(234,179,8,0.2)] relative z-10" data-id="element-414" data-mp="1k3oj4ezixugr">
              Garantía 7 días — Sin preguntas
            </h3>

            {/* Inner glowing card */}
            <div className="rounded-2xl border border-green-500/40 bg-slate-900/60 backdrop-blur-md px-6 py-8 md:px-10 text-center shadow-[0_0_30px_rgba(34,197,94,0.12)] relative z-10" data-id="element-415" data-mp="1yskqsaxo55gu">
              <p className="text-base md:text-lg text-slate-300 mb-4 font-medium" data-id="element-416" data-mp="nc46o4b660nn">
                Abrís el material. Lo usás en tus casos reales.
              </p>
              <p className="text-base md:text-lg text-slate-300 mb-6 font-medium" data-id="element-417" data-mp="jv8b7mrkd66g">
                Si en 7 días no es exactamente lo que esperabas:
              </p>
              <p className="text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-300 via-green-400 to-green-300 mb-4 drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-418" data-mp="ez143qnflomx">
                devolución del 100%
              </p>
              <p className="text-lg md:text-xl font-bold text-white" data-id="element-419" data-mp="16bfrfkfk7mn">
                sin formularios, sin drama, sin explicaciones.
              </p>
            </div>

            {/* Footer line */}
            <p className="text-sm text-slate-500 text-center mt-8 font-medium tracking-wide relative z-10" data-id="element-420" data-mp="avv2iwb9klms">
              Tasa de devoluciones:{' '}
              <span className="text-green-400 font-bold" data-id="element-421" data-mp="3ek6holzntuic">menos del 1%</span>.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="w-full bg-white py-14 px-4 relative overflow-hidden" data-id="element-422" data-mp="39ktkb7b5x51i">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" data-id="element-423" data-mp="331sykasl6p6"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-amber-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-424" data-mp="73bv1lvgrcyr"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-425" data-mp="gvhnsxtjhyf0">
          <div className="text-center mb-16" data-id="element-426" data-mp="gx2h6k44bbba">
            <span className="inline-block bg-yellow-100 text-yellow-800 font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-widest mb-4" data-id="element-427" data-mp="3gbekbocfez7c">
              Casos de éxito
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 text-center uppercase tracking-tight" data-id="element-428" data-mp="3pa00xdyc845h">
              Lo que dicen otros noveles abogados
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-429" data-mp="14llp2yj99m2u">
            {[{
            name: 'Valentina Rodríguez',
            age: 25,
            city: 'Buenos Aires',
            text: '"Me ordenó la cabeza completamente. Dejé de tardar horas en cosas básicas y ahora presento escritos con confianza."'
          }, {
            name: 'Matías González',
            age: 27,
            city: 'Córdoba',
            text: '"El paso a paso del PJN me ahorró errores reales. Lo recomiendo a cualquier novel que esté empezando."'
          }, {
            name: 'Lucía Fernández',
            age: 26,
            city: 'Rosario',
            text: '"Por fin entendí cómo cobrar mis honorarios sin sentirme incómoda. Vale cada peso."'
          }, {
            name: 'Sebastián Torres',
            age: 28,
            city: 'Mendoza',
            text: '"La guía de la primera entrevista me cambió todo. Ahora salgo con próximos pasos claros siempre."'
          }, {
            name: 'Camila Martínez',
            age: 25,
            city: 'Tucumán',
            text: '"Dejé de improvisar. Tengo un sistema real para ejercer y eso me da una seguridad que antes no tenía."'
          }, {
            name: 'Joaquín Pereyra',
            age: 26,
            city: 'La Plata',
            text: '"Pensé que iba a ser otro PDF más y me sorprendió mucho. Lo del PJN sobre todo, lo apliqué la misma semana y me funcionó."'
          }, {
            name: 'Florencia Acosta',
            age: 27,
            city: 'Salta',
            text: '"Recién recibida, sin estudio donde caerme. Esta guía fue la mano que necesitaba. Hoy facturo mejor y trabajo más tranquila."'
          }, {
            name: 'Tomás Iriarte',
            age: 24,
            city: 'Bahía Blanca',
            text: '"Lo bueno es que no es teoría boba. Es lo que necesitás cuando estás en el medio del lío y no sabés qué hacer. Súper práctico."'
          }, {
            name: 'Antonella Vega',
            age: 28,
            city: 'Neuquén',
            text: '"El grupo de WhatsApp solo ya vale la inversión. Te sacás dudas al toque con colegas que están en la misma."'
          }, {
            name: 'Bruno Salinas',
            age: 26,
            city: 'Posadas',
            text: '"Lo compré medio desconfiado, pero la verdad lo recomiendo. Me ordenó todo y dejé de sentirme perdido en cada trámite."'
          }].map((t, i) => <div key={i} className="bg-white rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.05)] hover:shadow-[0_0_30px_rgba(234,179,8,0.15)] hover:-translate-y-1 transition-all duration-300 p-8 border border-slate-200" data-id="element-430" data-mp="3a6ylmndfk7ea" data-mpi={i}>
                <div className="flex gap-1 mb-4 justify-center" data-id="element-431" data-mp="3f7cto5f17hcb">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-432" data-mp="2cuhog4z3ugzn" data-mpi={j} />)}
                </div>
                <p className="text-slate-700 mb-4 italic text-center" data-id="element-433" data-mp="2ltv2zc235vr8">
                  {t.text}
                </p>
                <div className="border-t pt-4 text-center border-slate-200" data-id="element-434" data-mp="2qm4v8yqob7wo">
                  <p className="font-bold text-slate-900" data-id="element-435" data-mp="2vkpnobzoonak">{t.name}</p>
                  <p className="text-sm text-slate-600" data-id="element-436" data-mp="2vmisrmunezgg">
                    {t.age} años — Abogado/a (1er año) — {t.city}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-gradient-to-b from-white via-slate-50 to-white py-10 px-4 relative overflow-hidden" data-id="element-437" data-mp="39jflxuy8ot0i">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-438" data-mp="1a97qi7w6o6v5">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-12 text-center uppercase" data-id="element-439" data-mp="1f6ppp6kef7py">
            ❓ Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-440" data-mp="12voz3temmfnf">
            {[{
            q: '¿Esto es para estudiantes?',
            a: 'No. Está pensado solo para noveles abogados en su primer año.'
          }, {
            q: '¿Es material digital?',
            a: 'Sí. Acceso y descarga inmediata.'
          }, {
            q: '¿Sirve en cualquier provincia?',
            a: 'Sí. Es válido para toda Argentina. (Y el bono del PJN aplica a los fueros principales.)'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No. Es paso a paso, pensado para arrancar con estructura.'
          }, {
            q: '¿Esto reemplaza asesoramiento legal?',
            a: 'No. Es material educativo y de apoyo práctico. La estrategia jurídica siempre depende del caso.'
          }, {
            q: '¿Cómo recibo el material después de pagar?',
            a: 'Apenas confirmás la compra, recibís un email con los enlaces de descarga y el acceso al grupo de WhatsApp. Es inmediato.'
          }, {
            q: '¿Qué métodos de pago puedo usar?',
            a: 'Aceptamos todas las tarjetas de crédito y débito, además de Mercado Pago. Podés pagar hasta en 3 cuotas según tu tarjeta.'
          }, {
            q: '¿Tiene actualizaciones futuras incluidas?',
            a: 'Sí. Mientras tengamos acceso de por vida, recibís las actualizaciones de modelos y normativa que vayamos sumando, sin costo extra.'
          }, {
            q: '¿Hay soporte si tengo dudas con el material?',
            a: 'Sí. Podés escribirnos por mail y además tenés el grupo de WhatsApp con +714 colegas y nuestro equipo para destrabar cualquier duda.'
          }, {
            q: '¿Cómo funciona la garantía de 7 días?',
            a: 'Tenés 7 días desde la compra para probarlo. Si no te resulta útil, nos escribís y te devolvemos el 100% del dinero sin preguntas.'
          }].map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-[0_0_15px_rgba(0,0,0,0.03)] hover:shadow-[0_0_25px_rgba(234,179,8,0.15)] transition-shadow duration-300" data-id="element-441" data-mp="3qve0k1bpd9cg" data-mpi={index}>
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-100 transition-colors" data-id="element-442" data-mp="2u4c5eb59iujr">
                  <span className="text-lg font-bold text-slate-900" data-id="element-443" data-mp="3361vndnernfy">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-6 w-6 text-slate-600 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-444" data-mp="idzru3ij4r0p" />
                </button>
                {openFaq === index && <div className="px-6 pb-6" data-id="element-445" data-mp="wqqpvsm6xhh8">
                    <p className="text-slate-700" data-id="element-446" data-mp="1bo9d2qj7zmmk">{faq.a}</p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Cost of Inaction Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-447" data-mp="izc45e0wf26h">
        <div className="absolute top-1/2 left-0 w-96 h-96 bg-red-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-448" data-mp="sqqcmbatvcbr"></div>
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-449" data-mp="nxdmfwqi2xgw"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-450" data-mp="71bse3vemmm">
          <div className="text-center mb-12" data-id="element-451" data-mp="3revti1yg80g9">
            <h2 className="text-3xl md:text-5xl font-black uppercase text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-452" data-mp="26xmqutcqnp3o">
              ⚖️ ¿Cuánto cuesta NO tenerlo?
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-2xl mx-auto font-light" data-id="element-453" data-mp="1wxdsp9z6rtln">
              No comprarlo también tiene un precio. Y se paga en tiempo, plata y
              oportunidades perdidas.
            </p>
          </div>

          <div className="bg-slate-800/40 backdrop-blur-xl rounded-3xl border border-slate-700/50 shadow-2xl overflow-hidden" data-id="element-454" data-mp="2unh2x8p8h9mv">
            {/* Table header */}
            <div className="grid grid-cols-2 bg-slate-900/80 border-b border-slate-700/50" data-id="element-455" data-mp="2gpsj846wk8je">
              <div className="py-5 px-5 md:px-8 text-center border-r border-slate-700/50" data-id="element-456" data-mp="2kqvvkgpqrmfv">
                <span className="text-sm md:text-lg font-black uppercase tracking-widest text-slate-300" data-id="element-457" data-mp="15adlgy6vdcn8">
                  Sin MegaPack
                </span>
              </div>
              <div className="py-5 px-5 md:px-8 text-center" data-id="element-458" data-mp="3bw05ym88ez25">
                <span className="text-sm md:text-lg font-black uppercase tracking-widest text-red-400" data-id="element-459" data-mp="36x6okiptqnwp">
                  Costo real
                </span>
              </div>
            </div>

            {[{
            without: 'Horas perdidas buscando modelos y formatos cada semana',
            cost: 'Semanas enteras de tu primer año tiradas a la basura'
          }, {
            without: 'Escritos rebotados por un formato mal armado',
            cost: 'Demoras, retrabajo y estrés que no para nunca'
          }, {
            without: 'Honorarios calculados "a ojo"',
            cost: 'Plata que dejás sobre la mesa en cada caso'
          }, {
            without: 'Trabas al subir escritos al portal del PJN',
            cost: 'Plazos en riesgo y clientes que se enojan'
          }, {
            without: 'Primera entrevista con clientes sin estructura',
            cost: 'Clientes que no vuelven ni te recomiendan'
          }, {
            without: 'Dudas que te frenan y nadie a quién preguntarle',
            cost: 'Avanzás lento y vivís corriendo atrás de todo'
          }, {
            without: 'Improvisar cada trámite desde cero',
            cost: 'El mismo caos el año que viene'
          }].map((row, i) => <div key={i} className={`grid grid-cols-2 border-b border-slate-700/40 ${i % 2 === 0 ? 'bg-slate-800/20' : 'bg-transparent'}`} data-id="element-460" data-mp="62z6eu86clr9" data-mpi={i}>
                <div className="py-5 px-5 md:px-8 border-r border-slate-700/40 flex items-start gap-3" data-id="element-461" data-mp="fwz9kqjwbgxc">
                  <XIcon className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-462" data-mp="1mhs26b4fxghv" />
                  <span className="text-sm md:text-base text-slate-300 font-medium leading-relaxed" data-id="element-463" data-mp="1rco01rwcyy2w">
                    {row.without}
                  </span>
                </div>
                <div className="py-5 px-5 md:px-8 flex items-start gap-3" data-id="element-464" data-mp="2vdxbmniclkna">
                  <span className="text-red-500 font-black flex-shrink-0 mt-0.5" data-id="element-465" data-mp="39cdrp523oni3">
                    ↳
                  </span>
                  <span className="text-sm md:text-base text-red-300 font-semibold leading-relaxed" data-id="element-466" data-mp="34bhh68n8u33p">
                    {row.cost}
                  </span>
                </div>
              </div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-467" data-mp="3e9dy5h2v3s9q">
            <p className="inline-block bg-yellow-500/10 border border-yellow-500/30 text-yellow-300 px-8 py-4 rounded-2xl text-lg md:text-xl font-bold shadow-[0_0_20px_rgba(234,179,8,0.1)]" data-id="element-468" data-mp="3s1k2m5wnkatc">
              El MegaPack cuesta menos que una sola semana perdida improvisando.
            </p>
          </div>

          <div className="flex justify-center mt-8" data-id="element-469" data-mp="xde1g3lxhdw">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-2xl px-12 py-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_50px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-300 uppercase text-center border-2 border-green-400" data-id="element-470" data-mp="ki42uklvoq47">
              QUIERO DEJAR DE PERDER TIEMPO
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="w-full bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black text-white py-14 px-4 border-t border-slate-800 relative overflow-hidden" data-id="element-471" data-mp="6jw201lq14nr">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-96 bg-yellow-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-472" data-mp="3svt6vt48vu9d"></div>
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
        backgroundSize: '64px 64px'
      }} data-id="element-473" data-mp="3iyog1fzgfam8"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-474" data-mp="1frh3rmuasy3w">
          <h2 className="text-4xl md:text-6xl font-black mb-8 uppercase text-center text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 tracking-tight drop-shadow-[0_0_15px_rgba(234,179,8,0.2)]" data-id="element-475" data-mp="1at5upebturmq">
            Tu primer año no tiene por qué ser "modo caos".
          </h2>
          <div className="bg-slate-800/50 backdrop-blur-md border border-slate-700/50 rounded-3xl p-8 md:p-12 mb-12 shadow-2xl" data-id="element-476" data-mp="1ygdx9ohvfml2">
            <p className="text-xl md:text-3xl mb-4 text-center text-slate-300 font-light" data-id="element-477" data-mp="1ui6gitneql9v">
              No necesitás más PDFs sueltos.
            </p>
            <p className="text-xl md:text-3xl text-center text-white font-medium" data-id="element-478" data-mp="j0ov3a9p28c5">
              Necesitás un sistema para ejercer con{' '}
              <span className="text-yellow-400 font-bold" data-id="element-479" data-mp="2um79g4q1i5sw">
                seguridad y velocidad
              </span>{' '}
              desde ya.
            </p>
          </div>
          {/* ÚLTIMO BOTÓN → CHECKOUT DIRECTO */}
          <a href="https://megapacknovelesabogados.impultienda.ar/" className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-2xl md:text-4xl px-16 py-8 rounded-2xl shadow-[0_0_40px_rgba(34,197,94,0.4)] hover:shadow-[0_0_60px_rgba(34,197,94,0.6)] transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center border-2 border-green-400" data-id="element-480" data-mp="38fow3ye0vyn5">
            QUIERO MI MEGAPACK
          </a>
        </div>
      </section>
    </div>;
}